import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../core/helpers/isMobile';

import WinLine from '../../../components/common/winLine';

const WinLineWrapper = observer(() => {
  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? 7 : 271,
        y: isMobile() ? 406 : 368,
      },
    };
  }, []);

  return <WinLine containerConfig={containerConfig} />;
});

export default WinLineWrapper;
